import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative py-14 sm:py-18 border-t border-[#C5A059]/10" data-testid="footer" id="contact">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
          {/* Brand */}
          <div>
            <p className="font-serif text-2xl text-[#F4F0EA]/80 mb-3">The Bridgette Emerald</p>
            <p className="text-sm text-[#B8B3AA]/60 leading-relaxed">
              A 1,055-carat museum-grade Colombian emerald crystal from the legendary Muzo region. Certified by Gubelin Gem Lab, Zurich.
            </p>
          </div>

          {/* Media Contact */}
          <div>
            <p className="text-xs text-[#C5A059]/60 uppercase tracking-[0.2em] mb-4">Media Contact</p>
            <p className="text-base text-[#F4F0EA]/75 font-medium mb-1">Blake Becher</p>
            <p className="text-sm text-[#B8B3AA]/60 mb-4">The Emerald Company — Founder, CEO</p>
            <div className="space-y-2">
              <a href="tel:+573186008080" className="flex items-center gap-3 text-sm text-[#B8B3AA]/70 hover:text-[#C5A059] transition-colors">
                <Phone size={14} strokeWidth={1.5} className="text-[#C5A059]/40" />
                +57 318 600 8080
              </a>
              <a href="mailto:blake.becher@emerald.rocks" className="flex items-center gap-3 text-sm text-[#B8B3AA]/70 hover:text-[#C5A059] transition-colors">
                <Mail size={14} strokeWidth={1.5} className="text-[#C5A059]/40" />
                blake.becher@emerald.rocks
              </a>
            </div>
          </div>

          {/* Address */}
          <div>
            <p className="text-xs text-[#C5A059]/60 uppercase tracking-[0.2em] mb-4">Address</p>
            <div className="flex items-start gap-3">
              <MapPin size={14} strokeWidth={1.5} className="text-[#C5A059]/40 mt-1 flex-shrink-0" />
              <p className="text-sm text-[#B8B3AA]/70 leading-relaxed">
                8 The Green, Suite A<br />
                Dover, DE 19901<br />
                United States
              </p>
            </div>
            <div className="mt-6">
              <p className="text-xs text-[#C5A059]/60 uppercase tracking-[0.2em] mb-2">For Enquiries</p>
              <a href="mailto:blake.becher@emerald.rocks" className="text-sm text-[#C5A059]/70 hover:text-[#C5A059] transition-colors">
                blake.becher@emerald.rocks
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#C5A059]/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#B8B3AA]/40">Confidential — All rights reserved</p>
          <p className="text-xs text-[#B8B3AA]/30">The information presented is subject to Non-Disclosure obligations.</p>
        </div>
      </div>
    </footer>
  );
}
